import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Observable, throwError } from 'rxjs'
import { catchError, tap } from 'rxjs/operators'

import { AuthenticationService } from './authentication.service'
import { isPublicSwpppPath } from './utility/public-anonymous-path'

/** Skips session-expired handling for auth-related API calls to avoid redirect loops. */
function isAuthUrl(url: string): boolean {
    const u = url.toLowerCase()
    return (
        u.includes('api/account/signin') ||
        u.includes('api/account/signup') ||
        u.includes('api/account/logout') ||
        u.includes('api/account/mfa/')
    )
}

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    private auth = inject(AuthenticationService)

    /** Prevents multiple toasts and redirects when several requests return 401 at once. */
    private static handling401 = false

    intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            tap((event: HttpEvent<unknown>) => {
                if (event instanceof HttpResponse && !isAuthUrl(req.url)) {
                    this.auth.resetIdleTimer()
                }
            }),
            catchError((error: HttpErrorResponse) => {
                // 401: API returned unauthorized (after ConfigureApplicationCookie runs after AddIdentity)
                // 404 + body "Account/Login": server redirected to login, client followed and got "Cannot GET /Account/Login" HTML
                const bodyStr = typeof error.error === 'string' ? error.error : ''
                const isSessionExpired =
                    (error.status === 401 && !isAuthUrl(req.url)) ||
                    (error.status === 404 && !isAuthUrl(req.url) && bodyStr.toLowerCase().includes('account/login'))
                if (isSessionExpired && !isPublicSwpppPath()) {
                    if (!AuthInterceptor.handling401) {
                        AuthInterceptor.handling401 = true
                        this.auth.clearAuthAndNavigateToSignIn(true)
                        setTimeout(() => {
                            AuthInterceptor.handling401 = false
                        }, 2000)
                    }
                }
                return throwError(() => error)
            }),
        )
    }
}
